module.exports = __webpack_public_path__ + "img/data-bg.d9376525.png";